import React from "react";

import companyBg01 from "@/shared/assets/img/company-bg01.png";
import companyBg02 from "@/shared/assets/img/company-bg02.png";
import companyBg03 from "@/shared/assets/img/company-bg03.png";
import companyBg04 from "@/shared/assets/img/company-bg04.png";
import companyBg05 from "@/shared/assets/img/company-bg05.png";

import companyBg01M from "@/shared/assets/img/company-bg01-m.png";
import companyBg02M from "@/shared/assets/img/company-bg02-m.png";
import companyBg03M from "@/shared/assets/img/company-bg03-m.png";
import companyBg04M from "@/shared/assets/img/company-bg04-m.png";
import companyBg05M from "@/shared/assets/img/company-bg05-m.png";

/**
 * CompanyContent - Company page content component
 * 회사 소개 페이지의 모든 섹션 포함
 */
export const CompanyContent: React.FC = () => {
  return (
    <main className="flex-1">
      {/* Company Section 1 */}
      <section className="w-full">
        <img
          src={companyBg01}
          alt="Company 1"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={companyBg01M}
          alt="Company 1 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* Company Section 2 */}
      <section className="w-full">
        <img
          src={companyBg02}
          alt="Company 2"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={companyBg02M}
          alt="Company 2 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* Company Section 3 */}
      <section className="w-full">
        <img
          src={companyBg03}
          alt="Company 3"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={companyBg03M}
          alt="Company 3 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* Company Section 4 */}
      <section className="w-full">
        <img
          src={companyBg04}
          alt="Company 4"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={companyBg04M}
          alt="Company 4 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* Company Section 5 */}
      <section className="w-full">
        <img
          src={companyBg05}
          alt="Company 5"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={companyBg05M}
          alt="Company 5 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>
    </main>
  );
};
